<template>
  <div>
    <div class="col">
      <div>
        <b-form-datepicker size="sm" @context="handleDateSelected($event)" v-model="p_date" class="mb-1"
          today-button close-button locale="zh" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"></b-form-datepicker>
      </div>
      
      <div>
        <b-table 
          striped 
          hover 
          sticky-header="1200px" 
          :small="true" 
          :busy="isBusy" 
          :items="stocks" 
          :fields="fields">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>加载中...</strong>
            </div>
          </template>
          <!-- 自定义列格式 -->
          <template #cell(px_change_rate)="data">
            <div :style="getPercentStyle(data.value, 10)">{{ data.value }}%</div>
          </template>
          <template #cell(rank_diff)="data">
            <div :style="getPercentStyle(data.value, 100)">{{ data.value }}</div>
          </template>
          <template #cell(stock_name)="data">
            <div class="text-truncate" style="max-width: 100px;" :title="data.value" @click="p_show_kline(data.item.stock_code, data.value)">{{ data.value }}</div>
          </template>

          <template #cell(stock_code)="data">
            <div class="stock-code-link" v-b-toggle.sidebar-right-stock @click="p_show_sidebar(data.value, data.item.stock_name)">{{ data.value }}</div>
          </template>

        </b-table>
      </div>
      <div class="mb-2 text-right">
        <b-button-group size="sm">
          <b-button variant="outline-primary" @click="exportStocks('csv')">导出CSV</b-button>
          <b-button variant="outline-success" @click="exportStocks('xlsx')">导出EXCEL</b-button>
        </b-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from "network/request.js"
import * as XLSX from 'xlsx'

export default {
  props: {
    plate_type: Number,
    plate_code: String,
    p_date: String,
  },
  data() {
    return {
      isBusy: true,
      stocks: [],
      fields: [
        {
          key: 'rank',
          label: '排名',
          sortable: true,
          thClass: 'text-center', 
          class: 'text-center', 
          thStyle: { width: '50px' }
        },
        {
          key: 'rank_diff',
          label: '变化',
          sortable: true,
          thClass: 'text-center', 
          class: 'text-center',
          thStyle: { width: '70px' }
        },
        {
          key: 'stock_name',
          label: '名称',
          sortable: true,
        },
        {
          key: 'stock_code',
          label: '代码',
          sortable: true,
          thClass: 'text-center', 
          class: 'text-center monospace',
        },
        {
          key: 'px_change_rate',
          label: '涨幅',
          sortable: true,
          thClass: 'text-right', 
          class: 'text-right',
          thStyle: { width: '80px' }
        }
      ]

    };
  },
  mounted() {
    this.refresh_popular();
  },
  watch: {
    plate_code(newPlateCode, oldPlateCode) {
      if (newPlateCode !== oldPlateCode) {
        this.refresh_popular();
      }
    },
    p_date(newDate, oldDate) {
      if (newDate !== oldDate) {
        this.refresh_popular();
      }
    }
  },
  methods: {
    p_show_kline(stock_code, stock_name) {
      this.$emit('p_show_kline', stock_code, stock_name)
    },
    p_show_sidebar(stock_code, stock_name) {
      this.$emit('p_show_sidebar', stock_code, stock_name)
    },
    exportFileName() {
      const datePart = this.p_date || ''
      const codePart = this.plate_code || 'plate'
      return `stocks_${codePart}_${datePart}`
    },
    exportStocks(format) {
      if (!Array.isArray(this.stocks) || this.stocks.length === 0) {
        return
      }
      const headers = this.fields.map(f => f.label)
      const keys = this.fields.map(f => f.key)
      const rows = this.stocks.map(item => {
        const row = {}
        keys.forEach((k, idx) => {
          row[headers[idx]] = item[k]
        })
        return row
      })
      const filename = this.exportFileName()
      if (format === 'xlsx') {
        const ws = XLSX.utils.json_to_sheet(rows, { header: headers })
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'stocks')
        const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([out], { type: 'application/octet-stream' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${filename}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        return
      }
      const csvHeader = headers.join(',')
      const csvBody = this.stocks.map(item => keys.map(k => {
        const val = item[k]
        const s = val === null || val === undefined ? '' : String(val)
        return '"' + s.replace(/"/g, '""') + '"'
      }).join(',')).join('\n')
      const csv = '\ufeff' + csvHeader + '\n' + csvBody
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${filename}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    refresh_popular() {
      this.isBusy = true;
      request_zzquant({
        url: '/v3/market/plates/'+this.plate_type+'/' + this.plate_code + '/stocks/rank?is_real=1&limit=100&date1=' + this.p_date
      })
      .then(res1 => {
        this.stocks = res1['data']['data'];
        this.isBusy = false;
      })
      .catch(err => {
        console.log(err);
        this.isBusy = false;
      });
    },
    handleDateSelected(event) {
      this.$emit('date-selected', event.selectedYMD);
    },
    getPercentStyle(val, scale = 10) {
      const v = parseFloat(val);
      if (isNaN(v) || v === 0) return { 'padding': '2px 4px', 'text-align': 'center' };

      const isUp = v > 0;
      // 归一化透明度，最大 0.9，最小 0.1
      let opacity = Math.min(Math.abs(v) / scale, 1) * 0.8 + 0.1;
      if (opacity > 0.9) opacity = 0.9;

      // 红色 (#ef4444) / 绿色 (#22c55e)
      const rgb = isUp ? '239, 68, 68' : '34, 197, 94';
      
      const style = {
        'background-color': `rgba(${rgb}, ${opacity})`,
        'border-radius': '4px',
        'padding': '2px 4px',
        'text-align': 'center',
        'font-weight': 'bold',
        'transition': 'all 0.2s'
      };

      // 高饱和度背景下强制白色文字
      if (opacity > 0.4) {
        style['color'] = '#fff';
      }

      return style;
    },
  }
};
</script>

<style scoped>
.table td {
  cursor: pointer;
  vertical-align: middle;
}
/* 紧凑表格样式 */
::v-deep .table-sm th,
::v-deep .table-sm td {
  padding: 0.3rem 0.5rem;
  font-size: 13px;
}
.monospace {
  font-family: 'IBM Plex Mono', 'Consolas', monospace;
}

.stock-code-link {
  cursor: pointer;
  color: #007bff; /* Default Bootstrap primary blue */
  font-weight: 500;
}

/* Dark mode overrides */
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

::v-deep .table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Specific Dark Mode Styles */
@media (prefers-color-scheme: dark) {
  /* Use CSS media query or rely on global class. Since we use body.theme-dark, we need that context */
}
</style>

<style>
/* Global overrides for this component when inside dark theme */
body.theme-dark .stock-code-link {
  color: #38bdf8 !important; /* Sky-400: Very bright blue/cyan for better contrast */
  font-weight: 600;
}

body.theme-dark .table-hover tbody tr:hover {
  background-color: #334155 !important; /* Explicit lighter dark color (Slate-700) instead of opacity */
  color: #ffffff !important;
}

/* Ensure hovered text inside links or specific cells is also readable */
body.theme-dark .table-hover tbody tr:hover td {
  color: #ffffff;
}

/* Fix stripe color in dark mode */
body.theme-dark .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.02);
}
</style>

